<template>
  <div class="logManage">
    <box title="日志管理">
      <div class="logManage__context">
        <div class="tool">
          <div class="checkAction">
            <p :class="{ action: isAction }" @click="getSysLog()">操作日志</p>
            <p :class="{ action: !isAction }" @click="getDeviceLog()">
              设备日志
            </p>
          </div>
        </div>

        <f-filter
          ref="filter"
          :need-btn="false"
          :filter-form="isAction ? formFilter : formFilter2"
          @sendForm="getForm"
        ></f-filter>

        <div class="tableList">
          <el-table v-loading="loading" :data="tableList">
            <el-table-column
              prop="userName"
              label="操作用户"
              show-overflow-tooltip
              width="180px"
              align="center"
            ></el-table-column>
            <el-table-column
              :prop="isAction ? 'clientTypeName' : 'imei'"
              :label="isAction ? '操作平台' : '操作设备'"
              width="220px"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="logInfo"
              label="操作内容"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="operateTime"
              width="220px"
              align="center"
              label="操作时间"
            ></el-table-column>
          </el-table>

        </div>
        <div class="page">
          <el-pagination
            @current-change="pageChange"
            background
            :current-page="page"
            :page-size="sizePage"
            layout="total,prev, pager, next, jumper"
            :total="totalSum"
          >
          </el-pagination>
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import box from "../../component/box";
import FFilter from "../../component/filter";
export default {
  name: "tagManger",
  components: { FFilter, box },
  data() {
    return {
      tableList: [],
      isAction: true,
      loading: false,
      page: 1,
      sizePage: 10,
      totalSum: 0,
      formFilter: [
        {
          name: "起止时间",
          endDate: "endDate",
          startDate: "startDate",
          type: "date",
          span: 9,
        },
      ],
      formFilter2: [
        {
          name: "起止时间",
          endDate: "endDate",
          startDate: "startDate",
          type: "date",
          span: 9,
        },
        {
          name: "设备IMEI",
          field: "imei",
          type: "input",
          span: 5,
        },
      ],
    };
  },
  methods: {
    pageChange(val) {
      this.page = val;
      this.$nextTick(() => {
        this.$refs.filter.onSearch();
      });
    },
    getSysLog() {
      this.isAction = true;
      this.$refs.filter.onSearch();
    },
    getDeviceLog() {
      this.isAction = false;
      this.$refs.filter.onSearch();
    },

    getForm(form, key) {
      if (key) {
        this.page = 1;
        if (this.isAction) {
          this.querySysLogPage(form);
        } else {
          this.queryDeviceLogPage(form);
        }
      } else {
        if (this.isAction) {
          this.querySysLogPage(form);
        } else {
          this.queryDeviceLogPage(form);
        }
      }
    },
    querySysLogPage(form) {
      this.loading = true;
      this.onClear();
      const prams = {
        pageNum: this.page,
        showNum: this.sizePage,
        startTime: form.startDate,
        endTime: form.endDate,
      };
      Axios.ajax({
        url: "/log/getSysLogPage",
        method: "post",
        data: prams,
      }).then(({ data }) => {
        this.loading = false;
        this.totalSum = data.totalNum;
        this.tableList = data.dataList;
      });
    },
    onClear() {
      this.tableList = [];
    },
    queryDeviceLogPage(form) {
      this.loading = true;
      this.onClear();
      const params = {
        url: "/log/getTerminalLogPage",
        method: "post",
        data: {
          endTime: form.endDate,
          startTime: form.startDate,
          imei: form.imei,
          pageNum: this.page,
          showNum: this.sizePage,
        },
      };
      Axios.ajax(params).then((res) => {
        if (res.data) {
          this.loading = false;
          this.tableList = res.data.dataList;
          this.totalSum = res.data.totalNum;
        }
      });
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.logManage {
  &__context {
    height: 100%;
    padding: 36px;
    overflow: auto;
    font-size: 14px;
    .tool {
      margin-bottom: 36px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .checkAction {
        display: flex;
        p {
          cursor: pointer;
          width: 84px;
          height: 44px;
          text-align: center;
          line-height: 44px;
          border-bottom: 2px solid #e4e7ed;
        }
        .action {
          color: #2a62ff;
          border-bottom: 2px solid #2a62ff;
        }
      }
    }
    .tableList {
      height: 62vh;
      position: relative;

    }
    .page {
      position: absolute;
      bottom: 40px;
      right: 40px;
    }
  }
}
</style>
